import "@rails/activestorage";
import "channels";
import Turbolinks from "turbolinks";
import Rails from "@rails/ujs";
import 'stylesheets/application';

import * as bootstrap from "bootstrap";

import "@fortawesome/fontawesome-free/js/all";
import "admin-lte";
import "proposals/form";
import "overlayscrollbars/js/jquery.overlayScrollbars";
import "pickadate/lib/picker";
import "pickadate/lib/picker.date";
import "jquery-mask-plugin/dist/jquery.mask.min";
import "select2/dist/js/select2";

import "./utils";
import "./select2";
import "./datepicker";
import "./masks";
import "./calculate_value_by_quantity";
import "./calculate_value_by_tax";
import "./calculate_values_in_purchase_commitment";
import "./show_fields_by_radio";
import "./show_fields_by_select";
import "./show_fields_by_checkbox";
import "./verify_ticket_status";
import "./quota_sovereign";
import "./tickets/loan";
import "./private_fixed_income_ted";
import "./invested_funds";
import "./invested_funds_passive";
import "./disable_fields_by_checkbox";
import "./change_options_by_select";
import "./card";
import "./delete-file-from-ticket";
import "./auto_refresh";
import "./monitor-tickets-form";
import "./filter_selic_asset_fields";
import "./filter_cetip_asset_fields";
import "./funds";
import "./managers";
import "./managers_cutoff";
import "./distributors_cutoff";
import "./transfer_funds";
import "./cetip_voice";
import "./margin-filter-fields";
import "./file_upload_name";
import "./input_many_files";
import "./show_cetip_voice_id";
import "./monitor-limit-per-page";
import "./proposals-limit-per-page";
import "./report";
import "./form_report";
import './hide_type_offer.js';
import "./shareholder_accounts_passive";
import './datatables';
import './statements';

//Adicionando novo js
import "./monitor_list";
import "./invested_funds_passive_monitor";
import { initSidebarMenuScroll, updateSidebarMenuScroll, watchSidebarMenuScroll } from "./portal_sidebar";


import Swal from "sweetalert2";

import $ from "jquery";
window.$ = $;
window.jQuery = $;

Turbolinks.start();
Rails.start();

const getSidebarPreferenceUrl = () => {
  const toggle = document.getElementById('sidebarToggle');
  return toggle?.dataset.sidebarPreferenceUrl || '/sidebar_preference';
};

const persistSidebarState = () => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  if (!csrfToken) return;

  const collapsed = document.body.classList.contains('sidebar-collapse');

  fetch(getSidebarPreferenceUrl(), {
    method: 'PATCH',
    credentials: 'same-origin',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({ collapsed }),
  }).catch(() => {});
};

const syncSidebarLogo = () => {
  const menuLogo = document.getElementById('menuLogo');
  if (!menuLogo) return;

  const collapsed = document.body.classList.contains('sidebar-collapse');
  const expandedSrc = menuLogo.dataset.logoExpanded;
  const collapsedSrc = menuLogo.dataset.logoCollapsed;

  if (collapsed && collapsedSrc) {
    menuLogo.src = collapsedSrc;
  } else if (expandedSrc) {
    menuLogo.src = expandedSrc;
  }

  menuLogo.removeAttribute('style');
};

const disposeSidebarNavTooltips = () => {
  document.querySelectorAll('[data-sidebar-nav-tooltip]').forEach((el) => {
    bootstrap.Tooltip.getInstance(el)?.dispose();
  });
};

const ensureSidebarNavTooltip = (el) => {
  if (!document.body.classList.contains('sidebar-collapse')) return;
  if (!el?.dataset.sidebarNavTooltip) return;
  if (bootstrap.Tooltip.getInstance(el)) return;

  new bootstrap.Tooltip(el, {
    placement: 'right',
    trigger: 'hover',
    boundary: 'window',
    title: el.dataset.sidebarNavTooltip,
    customClass: 'sidebar-nav-tooltip',
  });
};

const syncSidebarNavTooltips = () => {
  disposeSidebarNavTooltips();
};

document.addEventListener('turbolinks:before-visit', persistSidebarState);

document.addEventListener("turbolinks:load", () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltipTriggerEl) => {
    new bootstrap.Tooltip(tooltipTriggerEl);
  });

  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((popoverTriggerEl) => {
    new bootstrap.Popover(popoverTriggerEl);
  });

  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((dropdownTriggerEl) => {
    new bootstrap.Dropdown(dropdownTriggerEl);
  });

  initPortalSidebar();
  initSidebarMenuScroll();
  watchSidebarMenuScroll();
  syncSidebarLogo();
  syncSidebarNavTooltips();
});

const initPortalSidebar = () => {
  if (window.__portalSidebarInit) return;
  window.__portalSidebarInit = true;

  document.addEventListener('click', (event) => {
    const sidebarLink = event.target.closest('.main-sidebar a[href]:not([href="#"])');
    if (sidebarLink) {
      persistSidebarState();
    }

    if (event.target.closest('#sidebarToggle')) {
      window.setTimeout(() => {
        persistSidebarState();
        syncSidebarLogo();
        syncSidebarNavTooltips();
      }, 150);
    }
  }, true);

  document.addEventListener('mouseover', (event) => {
    const el = event.target.closest('[data-sidebar-nav-tooltip]');
    if (el) ensureSidebarNavTooltip(el);
  }, true);

  $(document).on('collapsed.lte.pushmenu shown.lte.pushmenu', () => {
    window.setTimeout(() => {
      persistSidebarState();
      syncSidebarLogo();
      syncSidebarNavTooltips();
      updateSidebarMenuScroll();
    }, 0);
  });
};

window.Swal = Swal;

const initDefaultSelect2 = () => {
  $('.select2').not('.JS-invested-funds-passive, .JS-invested-funds, .JS-funds').each(function () {
    if ($(this).hasClass('select2-hidden-accessible')) return;

    $(this).select2();
  });
};

document.addEventListener("turbo:load", initDefaultSelect2);

$(document).on('ready page:load', initDefaultSelect2);

$(document).ready(() => {
  $(".datepicker").pickadate();
  $(".mask").mask("000.000.000-00");
});

window.addEventListener('pageshow', function (event) {
  if (event.persisted || (typeof window.performance != 'undefined' && window.performance.navigation.type === 2)) {
    location.reload();
  }
});
